'use client'

import { useEffect, useRef } from 'react'

/**
 * Invokes onShow/onHide when isModalVisible transitions — not on mount or Strict Mode re-runs.
 *
 * onShow and onHide are intentionally excluded from the effect dependency array. Consumers
 * often pass inline handlers (e.g. onHide={() => clearErrors()}) and including them caused
 * infinite re-render loops. Callbacks are read from the render when visibility changed.
 */
export function useModalVisibilityCallbacks(
    isModalVisible: boolean,
    onShow?: () => void,
    onHide?: () => void,
): void {
    const previousIsModalVisibleRef = useRef(isModalVisible)

    useEffect(() => {
        const previousIsModalVisible = previousIsModalVisibleRef.current

        if (previousIsModalVisible === isModalVisible) {
            return
        }

        if (isModalVisible) {
            onShow?.()
        } else {
            onHide?.()
        }

        previousIsModalVisibleRef.current = isModalVisible
    }, [isModalVisible])
}
